import { InvoiceThreadFilters } from "../invoiceThreadFilters";
import { MegaraxUri } from "../uri";
import { LegacyRedirect, redirect, uuidParam } from "./redirect";

const myThreadsFilters: { filters: InvoiceThreadFilters } = {
  filters: {
    sort: { field: "invitedAt", order: "ASC" },
    status: ["open"],
    groupFilter: "mine",
    isMine: "true",
  },
};

export const invoiceRedirects: LegacyRedirect[] = [
  redirect("/faktury/wersje-robocze/nowa", () => MegaraxUri("megarax://invoices/drafts/new")),
  redirect("/faktury/wersje-robocze/:uuid/*", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://invoices/drafts/id/{id}", { id }) : undefined;
  }),
  redirect("/faktury/wersje-robocze", () => MegaraxUri("megarax://invoices/drafts")),

  redirect("/faktury/watki/moje-faktury", () => MegaraxUri("megarax://invoices/threads", myThreadsFilters)),
  redirect("/faktury/watki/moje_faktury", () => MegaraxUri("megarax://invoices/threads", myThreadsFilters)),
  redirect("/invoices/threads/my-invoices", () => MegaraxUri("megarax://invoices/threads", myThreadsFilters)),
  redirect("/faktury/watki/:uuid/*", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://invoices/threads/id/{id}", { id }) : undefined;
  }),
  redirect("/faktury/watki", () => MegaraxUri("megarax://invoices/threads")),

  redirect("/faktury/budzety/nowy", () => MegaraxUri("megarax://invoices/budgets/new")),
  redirect("/faktury/budzety/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://invoices/budgets/id/{id}", { id }) : undefined;
  }),
  redirect("/faktury/budzety", () => MegaraxUri("megarax://invoices/budgets")),
  redirect("/faktury", () => MegaraxUri("megarax://invoices/threads")),

  redirect("/invoices/threads/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://invoices/threads/id/{id}", { id }) : undefined;
  }),
  redirect("/invoices/drafts/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://invoices/drafts/id/{id}", { id }) : undefined;
  }),
  redirect("/invoices/budgets/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://invoices/budgets/id/{id}", { id }) : undefined;
  }),
];
